import { render, staticRenderFns } from "./hongbao-content.vue?vue&type=template&id=6baa33ed&"
import script from "./hongbao-content.vue?vue&type=script&lang=js&"
export * from "./hongbao-content.vue?vue&type=script&lang=js&"
import style0 from "./hongbao-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports